<div class="tw-bg-white dark:tw-bg-gray-800">
  <div class="tw-p-8">
    <!-- navigation buttons -->
    <div *ngIf="isDialog" class="tw-absolute tw-top-4 tw-right-16 tw-flex tw-gap-2">
      <button
        (click)="navigateBack()"
        [disabled]="!canNavigateBack()"
        class="tw-text-gray-600 dark:tw-text-gray-400 hover:tw-text-gray-700 dark:hover:tw-text-gray-200 tw-transition-colors disabled:tw-opacity-50 disabled:tw-cursor-not-allowed tw-border tw-border-gray-400 dark:tw-border-gray-600 tw-rounded tw-p-2 tw-border-solid tw-flex tw-items-center tw-gap-2 tw-h-8 tw-text-sm">
        <mat-icon>chevron_left</mat-icon>
        <span class="tw-hidden sm:tw-block">Previous</span>
      </button>
      <button
        (click)="navigateForward()"
        [disabled]="!canNavigateForward()"
        class="tw-text-gray-600 dark:tw-text-gray-400 hover:tw-text-gray-700 dark:hover:tw-text-gray-200 tw-transition-colors disabled:tw-opacity-50 disabled:tw-cursor-not-allowed tw-border tw-border-gray-400 dark:tw-border-gray-600 tw-rounded tw-p-2 tw-border-solid tw-flex tw-items-center tw-gap-2 tw-h-8 tw-text-sm">
        <span class="tw-hidden sm:tw-block">Next</span>
        <mat-icon>chevron_right</mat-icon>
      </button>
    </div>
    <!-- close button if in dialog -->
    <button
      *ngIf="isDialog"
      (click)="close()"
      class="tw-absolute tw-top-4 tw-right-4 tw-text-gray-600 dark:tw-text-gray-400 hover:tw-text-gray-700 dark:hover:tw-text-gray-200 tw-transition-colors">
      <mat-icon class="tw-leading-8">close</mat-icon>
    </button>
    <!-- top section -->
    <div class="tw-flex tw-items-start tw-justify-between tw-gap-4">
      <div class="tw-flex tw-gap-4 tw-mt-4">
        <div class="tw-w-24 tw-h-24 tw-hidden sm:tw-block">
          <mat-icon
            class="tw-text-gray-500 dark:tw-text-gray-500 tw-text-[100px] tw-leading-[86px] tw-w-full tw-h-full">
            account_circle_outline
          </mat-icon>
          <div
            *ngIf="freePreview"
            class="cool-icon tw-text-gray-500 dark:tw-text-gray-400 tw-text-[50px] tw-w-1/2 tw-h-1/2 tw-flex tw-items-center tw-justify-center">
            <mat-icon>question_mark</mat-icon>
          </div>
        </div>

        <div class="tw-flex tw-flex-col tw-gap-1 tw-mt-1">
          <h1
            class="tw-text-2xl tw-font-bold tw-text-gray-700 dark:tw-text-white tw-my-0 tw-flex tw-items-center tw-gap-4">
            {{ person.name }}
            <mat-icon
              *ngIf="!freePreview"
              class="md:tw-hidden tw-shrink-0 tw-h-5 tw-w-5 tw-leading-5 tw-text-[20px] tw-text-blue-800 dark:tw-text-blue-500">
              check_circle_outline
            </mat-icon>
            <span
              *ngIf="freePreview"
              class="tw-bg-yellow-200 tw-text-yellow-800 tw-border tw-border-solid tw-border-yellow-300 dark:tw-border-yellow-700 tw-text-xs tw-font-semibold tw-mr-2 tw-px-2.5 tw-py-0.5 tw-rounded-2xl dark:tw-bg-yellow-200 dark:tw-text-yellow-900 dark:tw-bg-opacity-80 tw-flex tw-items-center tw-gap-1">
              <mat-icon class="tw-text-yellow-800 tw-w-4 tw-h-4 tw-text-[15px]">lock</mat-icon>
              Free Preview
            </span>
          </h1>
          <p class="tw-text-lg tw-text-gray-600 dark:tw-text-gray-300 tw-my-0">
            {{ person.position?.title || 'Title not available' }}
          </p>
          <div class="tw-flex tw-items-center tw-gap-2 tw-text-gray-600 dark:tw-text-gray-300">
            <mat-icon class="tw-mr-1">business</mat-icon>
            <p class="tw-my-0">
              {{ person.position?.company.name || 'Company not available' }}
            </p>
          </div>
          <div
            *ngIf="person.country"
            class="tw-flex tw-items-center tw-gap-2 tw-text-gray-600 dark:tw-text-gray-300">
            <mat-icon class="tw-h-4 tw-text-[16px] tw-mr-1"> public </mat-icon>
            <p class="tw-my-0">
              {{ person.country }}
            </p>
          </div>
          <div
            *ngIf="person.connections"
            class="tw-flex tw-items-center tw-gap-2 tw-text-gray-600 dark:tw-text-gray-300 tw-mt-1">
            <img class="black-inverted-img tw-h-5 tw-w-5 tw-mr-2" src="assets/icons/linkedin.svg" />
            <span>{{ person.connections }} LI connections</span>
          </div>
        </div>
      </div>

      <!-- unlock btn -->
      <button
        *ngIf="freePreview && !authService.palModeValue"
        (click)="unlockFullProfile()"
        class="tw-text-sm tw-font-semibold tw-px-4 tw-py-2 tw-rounded-md tw-bg-blue-700 tw-text-blue-100 hover:tw-bg-blue-800 tw-transition-all tw-flex tw-items-center tw-self-center tw-gap-2"
        matTooltip="You can see the full profile for 1 credit. If you've already purchased this profile, no credit will be charged."
        matTooltipPosition="below">
        <mat-icon class="tw-shrink-0 tw-hidden sm:tw-block">key_vertical_outline</mat-icon>
        <span class="tw-hidden sm:tw-block">Unlock Full Profile</span>
        <span
          class="tw-flex tw-items-center tw-gap-2 tw-text-white tw-bg-white/20 tw-rounded-full tw-px-2.5 tw-py-0.5 tw-text-xs">
          1 <span class="tw-hidden">credit</span>
          <img src="../../../assets/icons/creditsw.svg" class="tw-w-4" />
        </span>
      </button>

      <!-- purchased badge -->
      <div
        *ngIf="!freePreview"
        class="tw-hidden md:tw-flex tw-items-center tw-gap-2 tw-px-4 tw-py-2 tw-rounded-md tw-bg-blue-100 dark:tw-bg-blue-900 dark:tw-bg-opacity-20 tw-text-blue-800 dark:tw-text-blue-500 tw-self-center tw-text-sm 
        tw-border tw-border-blue-200 dark:tw-border-blue-900 tw-border-solid">
        <mat-icon class="tw-shrink-0 tw-h-5 tw-w-5 tw-leading-5 tw-text-[20px]">
          check_circle_outline
        </mat-icon>
        <span class="tw-font-semibold">
          Full Profile <span class="tw-hidden sm:tw-inline">Purchased</span>
        </span>
      </div>
    </div>

    <div class="tw-flex tw-flex-col tw-gap-8 tw-mt-4">
      <!-- contact info section -->
      <div>
        <h2
          class="tw-text-lg tw-font-semibold tw-text-gray-800 dark:tw-text-gray-300 tw-mb-6 tw-pb-3 tw-flex tw-items-center tw-gap-2 tw-border-0 tw-border-solid tw-border-b tw-border-gray-200 dark:tw-border-gray-600">
          <mat-icon class="tw-text-gray-500 dark:tw-text-gray-400 tw-mr-1">person</mat-icon>
          Contact Info
        </h2>

        <!-- info grid -->
        <div
          class="tw-mt-3 tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-gap-4 tw-text-gray-600 dark:tw-text-gray-300">
          <div class="tw-flex tw-items-center tw-gap-2">
            <mat-icon class="w-w-4 tw-h-4 tw-text-[16px] tw-text-gray-500 dark:tw-text-gray-400">
              location_on
            </mat-icon>
            <span class="tw-font-semibold">Location:</span>
            <span
              *ngIf="freePreview"
              class="tw-bg-yellow-200 tw-text-yellow-800 tw-border tw-border-solid tw-border-yellow-300 dark:tw-border-yellow-700 tw-text-xs tw-font-semibold tw-mr-2 tw-px-2.5 tw-py-0.5 tw-rounded-2xl dark:tw-bg-yellow-200 dark:tw-text-yellow-900 dark:tw-bg-opacity-80 tw-flex tw-items-center tw-gap-1">
              <mat-icon class="tw-text-yellow-800 tw-w-4 tw-h-4 tw-text-[15px]">lock</mat-icon>
            </span>
            <span *ngIf="!freePreview" class="tw-text-gray-500 dark:tw-text-gray-400">
              {{ person.location }}
            </span>
          </div>
          <div class="tw-flex tw-items-center tw-gap-2">
            <img class="black-inverted-img tw-h-4 tw-w-4 tw-mr-2" src="assets/icons/linkedin.svg" />
            <span class="tw-font-semibold">LinkedIn:</span>
            <span
              *ngIf="freePreview"
              class="tw-bg-yellow-200 tw-text-yellow-800 tw-border tw-border-solid tw-border-yellow-300 dark:tw-border-yellow-700 tw-text-xs tw-font-semibold tw-mr-2 tw-px-2.5 tw-py-0.5 tw-rounded-2xl dark:tw-bg-yellow-200 dark:tw-text-yellow-900 dark:tw-bg-opacity-80 tw-flex tw-items-center tw-gap-1">
              <mat-icon class="tw-text-yellow-800 tw-w-4 tw-h-4 tw-text-[15px]">lock</mat-icon>
            </span>
            <span *ngIf="!freePreview" class="tw-text-gray-500 dark:tw-text-gray-400">
              <a href="https://www.linkedin.com/in/{{ person.linkedin }}" target="_blank">
                {{ person.linkedin }}
              </a>
            </span>
          </div>
          <div class="tw-flex tw-items-center tw-gap-2">
            <mat-icon class="w-w-4 tw-h-4 tw-text-[16px] tw-text-gray-500 dark:tw-text-gray-400">
              phone
            </mat-icon>
            <span class="tw-font-semibold">Cell number:</span>
            <span
              *ngIf="freePreview"
              class="tw-bg-yellow-200 tw-text-yellow-800 tw-border tw-border-solid tw-border-yellow-300 dark:tw-border-yellow-700 tw-text-xs tw-font-semibold tw-mr-2 tw-px-2.5 tw-py-0.5 tw-rounded-2xl dark:tw-bg-yellow-200 dark:tw-text-yellow-900 dark:tw-bg-opacity-80 tw-flex tw-items-center tw-gap-1">
              <mat-icon class="tw-text-yellow-800 tw-w-4 tw-h-4 tw-text-[15px]">lock</mat-icon>
            </span>
            <span *ngIf="!freePreview" class="tw-text-gray-500 dark:tw-text-gray-400">
              {{ person.cell_phone_number }}
            </span>
          </div>
          <div class="tw-flex tw-items-center tw-gap-2">
            <mat-icon class="w-w-4 tw-h-4 tw-text-[16px] tw-text-gray-500 dark:tw-text-gray-400">
              email
            </mat-icon>
            <span class="tw-font-semibold">Email:</span>
            <span
              *ngIf="freePreview"
              class="tw-bg-yellow-200 tw-text-yellow-800 tw-border tw-border-solid tw-border-yellow-300 dark:tw-border-yellow-700 tw-text-xs tw-font-semibold tw-mr-2 tw-px-2.5 tw-py-0.5 tw-rounded-2xl dark:tw-bg-yellow-200 dark:tw-text-yellow-900 dark:tw-bg-opacity-80 tw-flex tw-items-center tw-gap-1">
              <mat-icon class="tw-text-yellow-800 tw-w-4 tw-h-4 tw-text-[15px]">lock</mat-icon>
            </span>
            <span *ngIf="!freePreview" class="tw-text-gray-500 dark:tw-text-gray-400">
              {{ person.position?.email }}
            </span>
          </div>
        </div>
      </div>

      <!-- position info section -->
      <div>
        <h2
          class="tw-text-lg tw-font-semibold tw-text-gray-800 dark:tw-text-gray-300 tw-mb-6 tw-pb-3 tw-flex tw-items-center tw-gap-2 tw-border-0 tw-border-solid tw-border-b tw-border-gray-200 dark:tw-border-gray-600">
          <mat-icon class="tw-text-gray-500 dark:tw-text-gray-400 tw-mr-1">work</mat-icon>
          Current Job
        </h2>
        <div
          class="tw-mt-3 tw-columns-1 md:tw-columns-2 tw-gap-x-4 tw-text-gray-600 dark:tw-text-gray-300">
          <div
            *ngIf="person.position?.company?.name"
            class="tw-flex tw-items-center tw-gap-2 tw-mb-2">
            <span class="tw-font-semibold">Company:</span>
            <span class="tw-text-gray-500 dark:tw-text-gray-400">
              {{ person.position?.company?.name }}
            </span>
          </div>
          <div *ngIf="person.position?.title" class="tw-flex tw-items-center tw-gap-2 tw-mb-2">
            <span class="tw-font-semibold">Title:</span>
            <span class="tw-text-gray-500 dark:tw-text-gray-400">
              {{ person.position?.title }}
            </span>
          </div>
          <div *ngIf="person.position?.level" class="tw-flex tw-items-center tw-gap-2 tw-mb-2">
            <span class="tw-font-semibold">Job Level:</span>
            <span class="tw-text-gray-500 dark:tw-text-gray-400">
              {{ person.position?.level  }}
            </span>
          </div>
          <div *ngIf="person.position?.function" class="tw-flex tw-items-center tw-gap-2 tw-mb-2">
            <span class="tw-font-semibold">Job function:</span>
            <span class="tw-text-gray-500 dark:tw-text-gray-400">
              {{ person.position?.function }}
            </span>
          </div>
          <div class="tw-flex tw-items-center tw-gap-2 tw-mb-2">
            <span class="tw-font-semibold">Start date:</span>
            <span class="tw-text-gray-500 dark:tw-text-gray-400">
              {{ person.position?.started_at | date: 'MMM yyyy': 'UTC' }}
            </span>
          </div>
          <div *ngIf="person.position?.location" class="tw-flex tw-items-center tw-gap-2 tw-mb-2">
            <span class="tw-font-semibold">Job location:</span>
            <span class="tw-text-gray-500 dark:tw-text-gray-400">
              {{ person.position?.location }}
            </span>
          </div>
        </div>
      </div>
    </div>

    <!-- job history section -->
    <div class="tw-mt-8 tw-overflow-x-auto">
      <h2
        class="tw-text-lg tw-font-semibold tw-text-gray-800 dark:tw-text-gray-300 tw-mb-6 tw-pb-3 tw-flex tw-items-center tw-gap-2 tw-border-0 tw-border-solid tw-border-b tw-border-gray-200 dark:tw-border-gray-600">
        <mat-icon class="tw-text-gray-500 dark:tw-text-gray-400 tw-mr-1">history</mat-icon>
        Job History
      </h2>
      <div class="tw-mt-3 tw-text-gray-600 dark:tw-text-gray-300 tw-min-w-[680px]">
        <app-person-job-history-gantt [jobs]="person.jobs"></app-person-job-history-gantt>
      </div>
      <app-alert *ngIf="authService.palModeValue" alertType="info"
        >Public mode only shows limited job history.</app-alert
      >
    </div>

    <!-- education section -->
    <div class="tw-mt-8">
      <h2
        class="tw-text-lg tw-font-semibold tw-text-gray-800 dark:tw-text-gray-300 tw-mb-6 tw-pb-3 tw-flex tw-items-center tw-gap-2 tw-border-0 tw-border-solid tw-border-b tw-border-gray-200 dark:tw-border-gray-600">
        <mat-icon class="tw-text-gray-500 dark:tw-text-gray-400 tw-mr-1">school</mat-icon>
        Education
      </h2>
      <ng-container *ngIf="person.education?.length > 0; else noEducationInfo">
        <ng-container *ngIf="!freePreview">
          <div *ngFor="let education of person.education">
            <div
              class="tw-mt-3 tw-flex tw-items-center tw-gap-4 tw-justify-between tw-text-gray-600 dark:tw-text-gray-300">
              <div
                class="tw-flex tw-items-center tw-justify-center tw-bg-gray-700 tw-rounded-md tw-p-2">
                <img src="../../../assets/icons/school-building.svg" class="tw-w-4 tw-h-4" />
              </div>
              <div>
                <div class="tw-font-semibold">{{ education.school }}</div>
                <div class="tw-text-gray-700 dark:tw-text-gray-400 tw-text-sm">
                  {{ education.degree || 'Not available' }}
                </div>
              </div>
              <div
                class="tw-flex tw-items-center tw-ml-auto tw-bg-gray-700 tw-rounded-md tw-py-1 tw-px-2">
                <mat-icon
                  class="w-w-4 tw-h-4 tw-text-[16px] tw-text-gray-500 dark:tw-text-gray-400">
                  calendar_month
                </mat-icon>
                <span class="tw-text-gray-700 dark:tw-text-gray-400 tw-text-sm">
                  {{ education.graduated_at | date: 'yyyy' }}
                </span>
                <span class="tw-text-gray-700 dark:tw-text-gray-400 tw-text-sm"> 2009 </span>
              </div>
            </div>
          </div>
        </ng-container>

        <!-- If in free preview, list all schools on the left and show a single lock for all degrees on the right -->
        <ng-container *ngIf="freePreview">
          <div
            class="tw-mt-3 tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-gap-4 tw-text-gray-600 dark:tw-text-gray-300">
            <!-- Schools Column -->
            <div>
              <div
                *ngFor="let education of person.education; let last = last"
                class="tw-flex tw-items-center tw-gap-4"
                [class.tw-mb-4]="!last">
                <img src="../../../assets/icons/school-building.svg" class="tw-w-4 tw-h-4" />
                <span class="tw-font-semibold">School:</span>
                <span class="tw-text-gray-700 dark:tw-text-gray-400 tw-text-sm tw-font-medium">
                  {{ education.school }}
                </span>
              </div>
            </div>
            <!-- Locked Degrees Column -->
            <div
              class="tw-flex tw-items-center tw-gap-2"
              [ngClass]="{ 'tw-flex-col tw-bg-gray-100 dark:tw-bg-gray-700 tw-rounded-md tw-p-4 tw-justify-center': person.education.length > 1 }">
              <mat-icon
                class="tw-w-9 tw-h-11 tw-text-4xl tw-text-gray-500 dark:tw-text-gray-400"
                [ngClass]="{ 'tw-w-9 tw-h-11 tw-text-4xl': person.education.length > 1,
                'tw-w-4 tw-h-4 tw-text-[16px]': person.education.length < 1
               }">
                workspace_premium
              </mat-icon>
              <div class="tw-flex tw-items-center tw-gap-2">
                <span class="tw-font-semibold">Degree and graduation year:</span>
                <span
                  class="tw-bg-yellow-200 tw-text-yellow-800 tw-border tw-border-solid tw-border-yellow-300 dark:tw-border-yellow-700 tw-text-xs tw-font-semibold tw-mr-2 tw-px-2.5 tw-py-0.5 tw-rounded-2xl dark:tw-bg-yellow-200 dark:tw-text-yellow-900 dark:tw-bg-opacity-80 tw-flex tw-items-center tw-gap-1">
                  <mat-icon class="tw-text-yellow-800 tw-w-4 tw-h-4 tw-text-[15px]">lock</mat-icon>
                </span>
              </div>
            </div>
          </div>
        </ng-container>
      </ng-container>
      <ng-template #noEducationInfo>
        <p class="tw-text-gray-500 dark:tw-text-gray-400 tw-italic tw-my-0">
          No education information available for this person
        </p>
      </ng-template>
    </div>
  </div>
</div>
